<ras-page>
	<main>
		<h1>News / Articles</h1>
		<div class="articles" *ngIf="articles">
			<article *ngFor="let article of articles">
				<img [routerLink]="['/blog', article.slug]" [src]="'https://rentastore.co.za' + article.picture" alt="">

				<h2 [routerLink]="['/blog', article.slug]"> {{ article.title }} </h2>

				<p class="dateline"> {{ article.date | date : 'd MMMM yyyy' }} </p>

				<p> {{ article.summary }} </p>

				<p> <a [routerLink]="['/blog', article.slug]">Read more</a> </p>
			</article>
		</div>
	</main>
</ras-page>
